var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "#FFEBE5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#F8A792"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8878 19V18.02C10.8878 17.712 10.9485 17.4087 11.0698 17.11C11.2005 16.802 11.3825 16.4987 11.6158 16.2C11.8585 15.9013 12.1525 15.6213 12.4978 15.36L14.5278 13.834C14.7705 13.666 14.9805 13.4747 15.1578 13.26C15.3445 13.036 15.4892 12.8073 15.5918 12.574C15.6945 12.3313 15.7458 12.098 15.7458 11.874C15.7458 11.5473 15.6665 11.2533 15.5078 10.992C15.3492 10.7213 15.1252 10.5067 14.8358 10.348C14.5465 10.1893 14.2058 10.11 13.8138 10.11C13.4312 10.11 13.0952 10.1847 12.8058 10.334C12.5165 10.474 12.2785 10.6653 12.0918 10.908C11.9052 11.1413 11.7698 11.3933 11.6858 11.664L10.4818 11.426C10.5938 11.006 10.7945 10.614 11.0838 10.25C11.3825 9.886 11.7605 9.592 12.2178 9.368C12.6752 9.144 13.1838 9.032 13.7438 9.032C14.3972 9.032 14.9618 9.158 15.4378 9.41C15.9138 9.65267 16.2825 9.98867 16.5438 10.418C16.8145 10.838 16.9498 11.3187 16.9498 11.86C16.9498 12.3733 16.8098 12.8587 16.5298 13.316C16.2498 13.7733 15.8438 14.2167 15.3118 14.646L13.3938 16.102C13.0205 16.382 12.7312 16.676 12.5258 16.984C12.3298 17.292 12.2178 17.614 12.1898 17.95H17.0898V19H10.8878Z",
    fill: "#DE3E08"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step_2.582f913956b651c13caffc716d48fb76.svg";
export { ForwardRef as ReactComponent };